import z from 'zod';

export const mepEmailModalSchema = z.object({
  email: z.string({ required_error: 'Email is required' }).email(),
});
